import { NavItem, NavList, Navbar } from '@nucleus/sermon-theme-elements';
import { slugifyString } from '@nucleus/src-platform/data/text';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { useLocalization } from '../hooks/useLocalization';

interface Props {
  children?: React.ReactNode;
}

export const PostHubNav = (props: Props): JSX.Element => {
  const localize = useLocalization();

  return (
    <Navbar>
      <NavList>
        <NavItem as={NavLink} to="" end>
          {localize('home', 'Home')}
        </NavItem>
        <NavItem as={NavLink} to={slugifyString(localize('collections', 'Collections'))}>
          {localize('collections', 'Collections')}
        </NavItem>
        <NavItem as={NavLink} to={slugifyString(localize('authors', 'Authors'))}>
          {localize('authors', 'Authors')}
        </NavItem>
        <NavItem as={NavLink} to={slugifyString(localize('topics', 'Topics'))}>
          {localize('topics', 'Topics')}
        </NavItem>
        {props.children}
      </NavList>
    </Navbar>
  );
};
